import styled from 'styled-components';

export const Container = styled.div`
  margin: 1rem 0;
  font-family: Eesti, sans-serif;
  min-width: 0;
  max-width: 100%;
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-radius: 0.5rem;
  min-width: 0;
  max-width: 100%;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 1.4rem;
`;

export const Thead = styled.thead`
  background-color: rgba(0, 0, 0, 0.04);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

export const Tbody = styled.tbody`
  tr:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
`;

export const Tr = styled.tr``;

export const Th = styled.th`
  padding: 0;
  text-align: left;
  font-weight: 600;
  color: #111;
  white-space: nowrap;
  font-size: 1.4rem;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: stretch;
  min-height: 4.6rem;
`;

export const DragHandle = styled.button`
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  flex: 0 0 3.2rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: #9ca3af;
  cursor: grab;
  font-size: 1.8rem;
  touch-action: none;

  &:hover,
  &:focus-visible {
    color: #111827;
    background: rgba(0, 0, 0, 0.04);
  }

  &:active {
    cursor: grabbing;
  }
`;

export const SortButton = styled.div`
  appearance: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
  min-width: 0;
  width: 100%;
  padding: 1.2rem 1.6rem 1.2rem 0.4rem;
  border: 0;
  background: transparent;
  color: #111;
  cursor: pointer;
  font: inherit;
  font-weight: 600;
  text-align: left;

  &:hover,
  &:focus-visible {
    background: rgba(0, 0, 0, 0.04);
  }
`;

export const HeaderLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SortIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.4rem;
  height: 1.4rem;
  flex: 0 0 1.4rem;
  color: #6b7280;
  font-size: 1.2rem;
`;

export const Td = styled.td`
  padding: 1.2rem 1.6rem;
  vertical-align: top;
  color: #333;
  line-height: 1.55;
`;

export const ChartContainer = styled.div`
  width: 100%;
  height: 32rem;
  padding: 1.2rem 0.8rem 0;
  overflow: hidden;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  font-size: 1.2rem;
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.2rem;
  padding-bottom: 1rem;
  flex-wrap: wrap;
`;

export const ViewControls = styled.div`
  display: inline-flex;
  border: 1px solid #d1d5db;
  border-radius: 0.4rem;
  overflow: hidden;
`;

export const ViewButton = styled.button<{ $active: boolean }>`
  appearance: none;
  border: 0;
  border-right: 1px solid #d1d5db;
  background: ${({ $active }) => ($active ? `#111827` : `#fff`)};
  color: ${({ $active }) => ($active ? `#fff` : `#111827`)};
  cursor: pointer;
  min-width: 6rem;
  padding: 0.7rem 1rem;
  font-family: Eesti, sans-serif;
  font-size: 1.2rem;

  &:last-child {
    border-right: 0;
  }

  &:disabled {
    color: #9ca3af;
    background: #f3f4f6;
    cursor: not-allowed;
  }
`;

export const AxisControls = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  flex-wrap: wrap;
`;

export const SelectLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  color: #4b5563;
  font-size: 1.1rem;
  font-weight: 600;
  white-space: nowrap;
`;

export const SelectLabelHeader = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  white-space: nowrap;
`;

export const PieChartLayout = styled.div`
  display: flex;
  align-items: stretch;
  gap: 1.2rem;
  width: 100%;
  height: 100%;
  min-width: 0;
`;

export const PieChartArea = styled.div`
  flex: 1 1 50%;
  min-width: 0;
`;

export const PieLegend = styled.div`
  display: flex;
  flex: 1 1 50%;
  flex-direction: column;
  min-width: 0;
  max-width: 50%;
  overflow-y: auto;
`;

export const PieLegendHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 0.4rem 0.6rem;
`;

export const PieLegendSortButton = styled.button`
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: #4338ca;
  cursor: pointer;
  font: inherit;
  font-size: 1.2rem;
  font-weight: 600;

  &:hover,
  &:focus-visible {
    color: #312e81;
  }
`;

export const PieLegendSortIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  font-size: 1.1rem;
`;

export const PieLegendRow = styled.div<{ $dimmed?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.5rem 0.4rem;
  min-width: 0;
  opacity: ${({ $dimmed }) => ($dimmed ? 0.5 : 1)};
  transition: opacity 150ms ease;
  cursor: default;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
`;

export const PieLegendSwatch = styled.span<{ $color: string }>`
  flex: 0 0 1.2rem;
  width: 1.2rem;
  height: 0.3rem;
  border-radius: 0.2rem;
  background: ${({ $color }) => $color};
`;

export const PieLegendName = styled.span`
  overflow: hidden;
  flex: 1 1 auto;
  min-width: 0;
  color: #374151;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 1.2rem;
`;

export const PieLegendValue = styled.span`
  flex: 0 0 auto;
  color: #111827;
  white-space: nowrap;
  font-size: 1.2rem;
`;

export const Select = styled.select`
  min-width: 12rem;
  max-width: 22rem;
  height: 3.2rem;
  padding: 0 2.8rem 0 0.8rem;
  border: 1px solid #d1d5db;
  border-radius: 0.4rem;
  background: white;
  color: #111827;
  font-family: Eesti, sans-serif;
  font-size: 1.2rem;
`;
